var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.PrisaAdapter = youbora.Adapter.extend({

  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    if(this._settings.playHead>0)
      this._settings.lastPH = this._settings.playHead;

    if(this._settings.playHead>0)
      return this._settings.playHead;

    return this._settings.lastPH
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    return null
  },

  /** Override to return Frames Per Second (FPS) */
  getFramesPerSecond: function () {
    return null
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    return null
  },

  /** Override to return video duration */
  getDuration: function () {
    return this._settings.duration;
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    return null
  },

  /** Override to return user bandwidth throughput */
  getThroughput: function () {
    return null
  },

  /** Override to return rendition */
  getRendition: function () {
    return this._settings.rendition;
  },

  /** Override to return title */
  getTitle: function () {
    return this._settings.title;
  },

  /** Override to return title2 */
  getTitle2: function () {
    return this._settings.desc;
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return this._settings.isLive;
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this._settings.res;
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return "TopPlayer";
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return this._settings.player_name;
  },

  /** Override to return the video latency */
  getLatency: function () {
    return null
  },

  /** Override to return the amount of packets sent */
  getPacketSent: function () {
    return null
  },

  /** Override to return the amount of packets lost */
  getPacketLoss: function () {
    return null
  },
 
  //_settings: {},

  /** Register listeners to this.player. */
  registerListeners: function () {
    this._settings = {};

    if(typeof psdgetgetpsd!="undefined"){
      if(psdgetgetpsd("mm_youbora_debug"))
        mm_youbora_debug = true;
      if(psdgetgetpsd("mm_youbora_debug_2"))
        mm_youbora_debug_2 = true;
    }

    let _player_config = this.player.API.getSettings().topPlayer;
    let _that = this;
    _that.media = _that.player.API.getSettings()["id_media"];
    _that.laststatus = "";
    _that._seeking = false;

    // Console all events if logLevel=DEBUG
    if(typeof mm_youbora_debug!="undefined")
      console.log("%c{{YOUBORA}} Register Listeners","color:purple;font-weight:bold;",_that.media);

    if(typeof mm_youbora_debug!="undefined")
      youbora.Util.logAllEvents(this.player);

    // Enable playhead monitor (buffer = true, seek = false)
    if(_player_config.media.isLive){
      if(typeof mm_youbora_debug!="undefined")
        console.log("%c{{YOUBORA}} monitorPlayhead %cfalse %ctrue","color:purple;font-weight:bold;","color:cornflowerblue;font-weight:bold;","color:cornflowerblue;font-weight:bold;",_that.media);
      
      this.monitorPlayhead(false, true, 1200);
    }
    else{
      if(typeof mm_youbora_debug!="undefined")
        console.log("%c{{YOUBORA}} monitorPlayhead %ctrue %ctrue","color:purple;font-weight:bold;","color:cornflowerblue;font-weight:bold;","color:cornflowerblue;font-weight:bold;",_that.media);
      
      this.monitorPlayhead(true, true, 1200);
    }

    window.mm_yb = "21";
    if(typeof mm_youbora_debug!="undefined")console.log("%c{{mm_yb=" + mm_yb,"background:tomato;color:white;");

    let _current_status = "";
    _that.buffering_live = false;
    _that.href = window.location.href;

    _that.finiquitado = false;

    this.mm = _that.player.getMediaPlayer().getMediaModule();
    this.ad = _that.player.getMediaPlayer().getMediaModule();
    this.ui = _that.player.getMediaPlayer().getUIModule();

    _that.interval_timeshift = null;
    _that.player.youbora_adapter = _that;
    _that.player.onTimeshiftInfo = (e)=>{
      /*if(typeof mm_youbora_debug!="undefined")console.log("%c{{youbora}} TIMESHIFT INFO " + e + " (" + new Date(_that._settings.playHead).toLocaleString() + ")","background:blue;color:#fabada");
      _that._settings.playHead = e;

      clearInterval(_that.interval_timeshift);
      _that.interval_timeshift = setInterval(()=>{
        _that._settings.playHead += 1000;
        if(typeof mm_youbora_debug!="undefined")console.log("%c{{youbora}} TIMESHIFT playhead " + _that._settings.playHead + " (" + new Date(_that._settings.playHead).toLocaleString() + ")","background:#fabada;color:blue");
      },1000)*/
    };
    
    _that._settings.lastPH = 0;
    _that._settings.playHead = 0;
    _that._settings.duration = _player_config.media.duration/1000;
    _that._settings.title = _player_config.media.title;
    _that._settings.desc = _player_config.media.tags.programa.split(",")[0]||"";
    _that._settings.isLive = _player_config.media.isLive;
    _that._settings.isDVR = _player_config.media.isDVR;
    _that._settings.res = _player_config.media.url;
    _that._settings.provider = _player_config.media.provider;
    _that._settings.timeshift = _player_config.media.time_shifting;

    _that._interval_live = null;
    _that._time_interval_live = 0;
    _that.playing = false;
    _that._interval_ajax = null;
    _that.current_volume = -1;
    
    if(typeof _that._settings.res=="undefined"){
      if((typeof _player_config.media.urlHTML5!="undefined")&&(_player_config.media.urlHTML5.length>0))
      _that._settings.res = _player_config.media.urlHTML5[0];
    }
    _that._settings.playerName = _player_config.ui.skin;

    let current_plugin = _that;
    
    _that.inited = false;
    _that.joined = false;

    _that.set_interval_ajax = function(){
      if(!_that._settings.isLive){
        clearInterval(_that._interval_ajax);

        if(typeof mm_youbora_debug!="undefined"){
          console.log("%c{{YOUBORA}} Cargando interval AJAX","color:purple;font-weight:bold;",_that.media);
        }    

        _that._interval_ajax = setInterval(function(){
          if(typeof mm_youbora=="undefined")return;
          
          if((window.location.href!=_that.href)&&(typeof(mm_yb_ajax)!="undefined")){
            if(typeof mm_youbora_debug!="undefined"){
              console.log("%c{{YOUBORA}} Se ha cambiado la página por AJAX","color:red;font-weight:bold;");
              console.log("%c{{YOUBORA}} Evento fireStop","color:tomato;font-weight:bold;",ev);
            }
            _that.fireStop();
            if (_that.monitor) _that.monitor.stop();

            _that.playing = false;
            clearInterval(_that._interval_ajax);
            if(_that.inited){
              _that.playing = false;
            }
          }
        },1000)
      }
    }

    _that.externalInit = function(){
      //console.log("{{{{RESETING",window.mm_reseting);
      if(typeof window.mm_reseting!="undefined"){
        //console.log("{{{{{{{{{>>>>>>>>>>>>>>>>>>>hay reseting",mm_reseting)
        if(_that.media!=window.mm_reseting){
          _that.finiquitado = true;
          //console.log("{{youfiniquitado",_that.media,_that.finiquitado);
          return;
        }
      }

      window.mm_reseting = undefined;
      if(!_that.inited){
        //_that.fireInit();
        var _settings = _that.player.getSettings();
        console.log(_settings,_settings.topPlayer);

        if(!_settings.topPlayer.media.autoplay){
          if(typeof mm_youbora_debug!="undefined")console.log("%c{{YOUBORA}} RESET SIN AUTOPLAY","color:red;background:gold;font-weight:bold;",_that.media);
          return
        }
          
        _that.player.ybplugin.fireInit();

        _that.inited = true;
        if(typeof mm_youbora_debug!="undefined"){
          console.log("%c{{YOUBORA}} Evento fireInit de %s","color:white;background:blue;font-weight:bold;",_that.media);
        }

        if(_that.player.API.getSettings(true)["media_type"]=="video"){
          if(typeof mm_youbora_debug!="undefined")console.log("%c{{YOUBORA}} Cargando interval AJAX","color:#333;background:pink;font-weight:bold;",_that.media);
          _that.set_interval_ajax();
        }
      }
    }

    if(typeof mm_youbora_debug!="undefined"){
      console.log("%c{{YOUBORA}} Cargando player con settings:","color:purple;font-weight:bold;",_that.media,_that._settings);
      console.log("%c{{YOUBORA}} TopPlayer config -> ","color:purple;font-weight:bold;",_that.media,_that.player.getSettings().id_media,_that.player.getSettings().topPlayer.media.autoplay);
    }

    if(_that.player.getSettings().topPlayer.media.autoplay){
      _that.externalInit();
    }

    if(typeof mm_yb_items=="undefined"){
      mm_yb_items = [];
    }

    _that.id = "yb" + Math.floor(Math.random()*1000);
    _that.set = this._settings;

    mm_yb_items.push(_that);

    _that.set_interval_live = function(){
      if(_that._settings.isLive){
        clearInterval(_that._interval_live);
        _that._time_interval_live = 0;

        if(typeof mm_youbora_debug!="undefined"){
          console.log("%c{{YOUBORA}} Cargando interval LIVE","color:purple;font-weight:bold;",_that.media);
        }    

        _that._interval_live = setInterval(function(){
          if(typeof mm_youbora=="undefined")return;

          if(_that.playing)
            _that._time_interval_live++;
          
            if(typeof mm_youbora_debug_2!="undefined"){
              console.log("%c{{YOUBORA}} interval directos:","color:green;font-weight:bold;",_that._time_interval_live);
            }

            if(!_that._settings.isDVR&&!_that._settings.timeshift){
              current_plugin._settings.playHead = _that._time_interval_live;
              if(typeof mm_youbora_debug_2!="undefined"){console.log("%cPlayHead = ","color:chocolate",current_plugin._settings.playHead);}
            }
        },1000)
      }
    }

    window.stopYB = function(){
      if (_that.monitor) _that.monitor.stop()
      _that.fireStop();
      clearInterval(_that._interval_live);
      clearInterval(_that._interval_ajax);
    }

    // References
    this.references = {
      "try_play": function(){
        let _f_init = function(ev){
          if(typeof mm_youbora=="undefined")return;

          //_that.fireStart();
          if(_that.inited){
            return;
          }

          if(typeof mm_youbora_debug!="undefined"){
            console.log("%c{{YOUBORA}}  Evento fireInit","color:tomato;font-weight:bold;");
          }
          _that.fireInit();
          _that.inited = true;
        }
        _that.mm.removeEventListener(emic.top.event.MediaEvent.ON_LOADING_START,_f_init,null,"youbora_init");
        _that.mm.addEventListener(emic.top.event.MediaEvent.ON_LOADING_START,_f_init,null,"youbora_init");
      },
      "reset": function(){
        let _f_reset = function(ev){
          if(typeof mm_youbora=="undefined")return;

          if(typeof mm_youbora_debug!="undefined"){
            console.log("%c{{YOUBORA}}  Evento reset - inicilizado?","color:tomato;font-weight:bold;",_that.inited);
          }
          //_that.fireStart();
          clearInterval(_that._interval_live);
//console.log("{{{{{{{reseteando",_that.media);
          _that.finiquitado = true;
          _that._seeking = false;

          if(!_that.inited)
              return;

          if(typeof window.mm_reseting!="undefined"){
            if(typeof mm_youbora_debug!="undefined"){
              console.log("%c{{YOUBORA}} Evento fireStop","color:tomato;font-weight:bold;",ev);
            }
            _that.fireStop();
          }
          
          //if(_that.inited){
          _that.playing = false;
          if (_that.monitor) _that.monitor.stop();

          _that.inited = false;
          //}
        }
        _that.mm.removeEventListener(emic.top.event.MediaEvent.ON_RESET_COMPLETE,_f_reset,null,"youbora_reset");
        _that.mm.addEventListener(emic.top.event.MediaEvent.ON_RESET_COMPLETE,_f_reset,null,"youbora_reset");
      },
      "rendition": function(){
        let _f_rendition = function(ev){
          if(typeof mm_youbora=="undefined")return;

          if(!_that.inited)
              return;

          if(typeof ev.data.index!="undefined"){
            _that._settings.rendition = ev.data.index.data;
          }else{
            _that._settings.rendition = _that.player.renditions[ev.data].label;
          }
          
          if(typeof mm_youbora_debug!="undefined"){
            console.log(ev);
            console.log("%c{{YOUBORA}}  Evento rendition ","color:tomato;font-weight:bold;",_that._settings.rendition);
          }
        }
        _that.ui.removeEventListener(emic.top.event.UIEvent.ON_ORDER_SWITCH_DIRECT,_f_rendition,null,"youbora_rendition");
        _that.ui.addEventListener(emic.top.event.UIEvent.ON_ORDER_SWITCH_DIRECT,_f_rendition,null,"youbora_rendition");

        _that.mm.removeEventListener(emic.top.event.MediaEvent.ON_SWITCH_COMPLETE,_f_rendition,null,"youbora_rendition");
        _that.mm.addEventListener(emic.top.event.MediaEvent.ON_SWITCH_COMPLETE,_f_rendition,null,"youbora_rendition");
      },
      "volume": function(){
        let _f_volume = function(ev){
          if(typeof mm_youbora=="undefined")return;

          if((ev.data==0)&&(_that.current_volume!=0)&&(_that._settings.isLive)){
            if(typeof mm_youbora_debug!="undefined"){
              console.log("%c{{YOUBORA}} Evento firePause provocado por MUTE","color:tomato;font-weight:bold;",ev);
            }
            _that.playing = false;
            _that.firePause();
          }

          _that.current_volume = ev.data;
        };

        _that.mm.removeEventListener(emic.top.event.MediaEvent.ON_VOLUME_CHANGE,_f_volume,null,"youbora_volume");
        _that.mm.addEventListener(emic.top.event.MediaEvent.ON_VOLUME_CHANGE,_f_volume,null,"youbora_volume");
      },
      "playpause": function(){ 
          let _f_playpause = function(ev){
            if(typeof mm_youbora=="undefined")return;

            if(!_that.inited)
              return;
            if(_current_status==ev.data.status)
              return;

              //console.log(">>{{",_current_status,ev.data.status);
          _current_status = ev.data.status;

          if(ev.data.status=="play"){
            if(typeof mm_youbora_debug!="undefined"){
              console.log("%c{{YOUBORA}} Evento fireResume","color:tomato;font-weight:bold;",ev);
            }
            _that.playing = true;
            if((_that._settings.isLive)&&(_that.buffering_live)){
              if(typeof mm_youbora_debug!="undefined"){
                console.log("%c{{YOUBORA}} Evento fireBufferEnd #2","color:mediumpurple;font-weight:bold;",ev);
              }
              _that.buffering_live = false;
              _that.fireBufferEnd();
            }
            if(_that._seeking){
              _that.fireSeekEnd();
              if(typeof mm_youbora_debug!="undefined"){
                console.log("%c{{YOUBORA}} Evento fireSeekEnd","color:tomato;font-weight:bold;",ev);
              }
              _that._seeking = false;
            }
            _that.fireResume();
          }
          else{
            if((ev.data.status=="pause")||(ev.data.status=="stop")){
              clearInterval(_that.interval_timeshift);
              if(typeof mm_youbora_debug!="undefined"){
                console.log("%c{{YOUBORA}} Evento firePause","color:tomato;font-weight:bold;",ev);
              }
              _that.playing = false;
              _that.firePause();
            }
          }
        };
        
        _that.mm.removeEventListener(emic.top.event.MediaEvent.ON_STATUS_CHANGE,_f_playpause,null,"youbora_playpause");
        _that.mm.addEventListener(emic.top.event.MediaEvent.ON_STATUS_CHANGE,_f_playpause,null,"youbora_playpause");
      },
      "playing": function(){
        let _f_playing = function(){
          if(typeof mm_youbora=="undefined")return;

          if(!_that.inited){
            if(typeof mm_youbora_debug!="undefined"){
              console.log("%c{{YOUBORA}} Evento fireInit","color:tomato;font-weight:bold;");
            }
            _that.fireInit();
          }
          if(!_that.joined){
            if(typeof mm_youbora_debug!="undefined"){
              console.log("%c{{YOUBORA}} Evento fireJoin","color:orange");
            }

            _that.fireJoin();
            _that.joined = true;
          }

          _that.set_interval_live();
        };

        _that.mm.removeEventListener(emic.top.event.MediaEvent.ON_MEDIA_BEGIN,_f_playing,null,"youbora_playing");
        _that.mm.addEventListener(emic.top.event.MediaEvent.ON_MEDIA_BEGIN,_f_playing,null,"youbora_playing");
      },
      "error": function(){
        let _f_error = function(ev){
          if(typeof mm_youbora=="undefined")return;

          if(typeof mm_youbora_debug!="undefined"){
            console.log("%c{{YOUBORA}} Evento fireError","color:tomato;font-weight:bold;",ev);
          }          
          if((typeof ev.data.code!="undefined")&&(ev.data.code!=null)&&(ev.data.code=="LIVE_CONNECTING"))
            console.log("%c{{YOUBORA}} Live connecting -> no se envía","color:tomato;font-weight:bold;")
          else{
            var error_desc = "TOP Error";

            if((typeof ev.data.code!="undefined")&&(ev.data.code!=null)&&(ev.data.code=="LIVE_FAILED")){
              console.log("%c{{YOUBORA}} Error de conexión temporal -> no se envía","color:tomato;font-weight:bold;",ev);
              error_desc = "Error temporal de conexión"
            }else{
              _that.fireError(ev.data.code, error_desc, "top_error", 1);
              if(typeof mm_youbora_debug!="undefined"){
                console.log("%c{{YOUBORA}} Evento fireStop tras error","color:tomato;font-weight:bold;",ev);
              }
              _that.fireStop();
              _that.playing = false;
              clearInterval(_that._interval_live);
              if (_that.monitor) _that.monitor.stop()
                _that.inited = false;
              }
            }
        };

        _that.mm.removeEventListener(emic.top.event.MediaEvent.ON_ERROR,_f_error,null,"youbora_error");
        _that.mm.addEventListener(emic.top.event.MediaEvent.ON_ERROR,_f_error,null,"youbora_error");
      },
      "seeking": function(){
        let _f_seeking = function(){
          if(typeof mm_youbora=="undefined")return;

          if(!_that.inited)
              return;

          if((_that._settings.isDVR)||(_that._settings.provider=="youtube")||(_that._settings.timeshift)){
            if(typeof mm_youbora_debug!="undefined"){
              console.log("%c{{YOUBORA}} Evento fireSeekBegin","color:tomato;font-weight:bold;",ev);
            }
            _that.fireSeekBegin();
            _that._seeking = true;
          }
        };

        _that.mm.removeEventListener(emic.top.event.MediaEvent.ON_SEEK_START,_f_seeking,null,"youbora_seeking");
        _that.mm.addEventListener(emic.top.event.MediaEvent.ON_SEEK_START,_f_seeking,null,"youbora_seeking");

        if(_that._settings.timeshift)
          _that.player.onCOREEVENT("seekstart",
            _f_seeking,"youbora seekstart");
      },
      "seeked": function(ee){
        let _f_seeked = function(ee){
          //console.log("youbora seek",ee,ee/60,ee/60/60);
          if(typeof mm_youbora=="undefined")return;

          if(!_that.inited)
              return;

          if((_that._settings.isDVR)||(_that._settings.provider=="youtube")||(_that._settings.timeshift)){
            if(typeof mm_youbora_debug!="undefined"){
              console.log("%c{{YOUBORA}} Evento fireSeekEnd","color:tomato;font-weight:bold;",ev);
            }
            _that.fireSeekEnd();
            _that._seeking = false;
          }
        };

        _that.mm.removeEventListener(emic.top.event.MediaEvent.ON_SEEK_COMPLETE,_f_seeked,null,"youbora_seeked");
        _that.mm.addEventListener(emic.top.event.MediaEvent.ON_SEEK_COMPLETE,_f_seeked,null,"youbora_seeked");

        if(_that._settings.timeshift)
          _that.player.onCOREEVENT("seekend",
            _f_seeked,"youbora seekend");
      },    
      "buffering": function(){
        let _f_buffering = function(){
          if(typeof mm_youbora=="undefined")return;
          
          if(_that._settings.isLive){
            _that.buffering_live = true;

            if(typeof mm_youbora_debug!="undefined"){
              console.log("%c{{YOUBORA}} Evento fireBufferBegin #1","color:mediumpurple;font-weight:bold;",ev);
            }
            _that.fireBufferBegin();
            
            if (_that.monitor) _that.monitor.skipNextTick();
          }
        };

        _that.mm.removeEventListener(emic.top.event.MediaEvent.ON_BUFFER_EMPTY,_f_buffering,null,"youbora_buffering");
        _that.mm.addEventListener(emic.top.event.MediaEvent.ON_BUFFER_EMPTY,_f_buffering,null,"youbora_buffering");
      },
      "buffered": function(){
        let _f_buffered = function(){
          if(typeof mm_youbora=="undefined")return;

          if((_that._settings.isLive)&&(_that.buffering_live)){
            if(typeof mm_youbora_debug!="undefined"){
              console.log("%c{{YOUBORA}} Evento fireBufferEnd #1","color:mediumpurple;font-weight:bold;",ev);
            }
            _that.buffering_live = false;
            _that.fireBufferEnd();
          }
        };

        _that.mm.removeEventListener(emic.top.event.MediaEvent.ON_BUFFER_FULL,_f_buffered,null,"youbora_buffered");
        _that.mm.addEventListener(emic.top.event.MediaEvent.ON_BUFFER_FULL,_f_buffered,null,"youbora_buffered");
      },  
      "ended": function(){
        let f_ended = function(){
          if(typeof mm_youbora=="undefined")return;

          if(!_that.inited)
              return;
              
          if(typeof mm_youbora_debug!="undefined"){
            console.log("%c{{YOUBORA}} Evento fireStop","color:tomato;font-weight:bold;",ev);
          }
          _that.fireStop();
          _that.playing = false;
          clearInterval(_that._interval_live);
          if (_that.monitor) _that.monitor.stop()
          _that.inited = false;
        };

        _that.mm.removeEventListener(emic.top.event.MediaEvent.ON_MEDIA_END,f_ended,null,"youbora_ended");
        _that.mm.addEventListener(emic.top.event.MediaEvent.ON_MEDIA_END,f_ended,null,"youbora_ended");
      },
      "timeupdate": function(){
        let f_timeupdate = function(){
          if(typeof mm_youbora=="undefined")return;

          if(!_that.inited){
            _that.fireInit();
            if(typeof mm_youbora_debug!="undefined"){
              console.log("%c{{YOUBORA}} Evento fireInit","color:gold");
            }
            if(_that._settings.isDVR){
              _that.fireJoin();
              _that.joined = true;
              if(typeof mm_youbora_debug!="undefined"){
                console.log("%c{{YOUBORA}} Evento fireJoin","color:orange");
              }
            }
            _that.inited = true;
          }

          /*if(document.getElementById("ttu")&&(document.getElementById("ttu").checked)){
            if (current_plugin.getPlayhead() > 0.1) {
              if(typeof mm_youbora_debug!="undefined")console.log("Evento TIMEUPDATE",ev);
              //_that.fireJoin();
            }
          }*/

          current_plugin._settings.playHead = ev.data.currentTime;
          if(typeof mm_youbora_debug_2!="undefined"){console.log("%cPlayHead = ","color:chocolate",current_plugin._settings.playHead);}
        }
        _that.mm.removeEventListener(emic.top.event.MediaEvent.ON_PROGRESS,f_timeupdate,null,"youbora_timeupdate");
        _that.mm.addEventListener(emic.top.event.MediaEvent.ON_PROGRESS,f_timeupdate,null,"youbora_timeupdate");
      },
      "positionchange": function(){
        let f_positionchange = function(evt){
          if(typeof mm_youbora=="undefined")return;
          if(_that.finiquitado)return;

          _that.externalInit();

          if(typeof mm_youbora_debug!="undefined"){
            console.log("%c{{YOUBORA}} position change","background:yellowgreen;color:white;font-weight:bold;",evt.data.lastPosition," -> ",evt.data.position,_that.media);
          }

          if((evt.data.position=="positionMedia")&&(!_that.joined)&&(_that.inited)){
            /*
            if(typeof mm_youbora_debug!="undefined"){
              console.log("%c{{YOUBORA}} Evento fireJoin","color:orange");
            }

            alert(2);
            _that.fireJoin();
            _that.joined = true;*/
          }

          if((evt.data.position=="positionPreview")&&(evt.data.lastPosition=="positionMedia")){
            if(window.mm_reseting){
              if(typeof mm_youbora_debug!="undefined"){
                console.log("%c{{YOUBORA}} Evento fireStop por new init","color:tomato;font-weight:bold;",ev);
              }
              _that.fireStop();
              _that.playing = false;
              clearInterval(_that._interval_live);
              if (_that.monitor) _that.monitor.stop()
              _that.inited = false;
            }
          }
        }

        _that.player.getMediaPlayer().removeEventListener(emic.top.event.TopEvent.ON_POSITION_CHANGE,f_positionchange,"youbora_positionchange");
        _that.player.getMediaPlayer().addEventListener(emic.top.event.TopEvent.ON_POSITION_CHANGE,f_positionchange,"youbora_positionchange");
      }                 
      //'play': this.playListener.bind(this),
      //'pause': this.pauseListener.bind(this),
      //'playing': this.playingListener.bind(this),
      //'error': this.errorListener.bind(this),
      //'seeking': this.seekingListener.bind(this),
      //'seeked': this.seekedListener.bind(this),
      //'buffering': this.bufferingListener.bind(this),
      //'buffered': this.bufferedListener.bind(this),
      //'ended': this.endedListener.bind(this),
      //'timeupdate': this.timeupdateListener.bind(this)
    }

    // Register listeners
    if (this.player && this.references) {
      Object.keys(this.references).forEach(function (key) {
        //this.player.addEventListener(key, this.references[key])
        this.references[key]();
      }.bind(this))
    }
  },

  // Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    clearInterval(_that._interval_live);
    if (this.monitor) this.monitor.stop();
    _that.playing = false;

    // unregister listeners
    if (this.player && this.references) {
      Object.keys(this.references).forEach(function (key) {
        this.player.removeEventListener(key, this.references[key])
      }.bind(this))
      this.references = {}
    }
  }/*,

  // Listener for 'play' event. 
  playListener: function (e) {
    this.fireStart()
  },

  // Listener for 'timeupdate' event. 
  timeupdateListener: function (e) {
    if (getPlayhead() > 0.1) {
      this.fireJoin()
    }
  },

  // Listener for 'pause' event. 
  pauseListener: function (e) {
    this.firePause()
  },

  // Listener for 'playing' event. 
  playingListener: function (e) {
    this.fireResume()
    this.fireSeekEnd()
    ///this.fireBufferEnd()
    this.fireJoin()
  },

  // Listener for 'error' event. 
  errorListener: function (e) {
    this.fireError()
  },

  // Listener for 'seeking' event. 
  seekingListener: function (e) {
    this.fireSeekBegin()
  },

  // Listener for 'seeked' event. 
  seekedListener: function (e) {
    this.fireSeekEnd()
  },

  // Listener for 'buffering' event. 
  bufferingListener: function (e) {
    ///this.fireBufferBegin()
  },

  // Listener for 'buffered' event. 
  bufferedListener: function (e) {
    ///this.fireBufferEnd()
  },

  // Listener for 'ended' event. 
  endedListener: function (e) {
    this.fireStop()
  }*/
})

module.exports = youbora.adapters.PrisaAdapter
